import { useDatabase } from "@nozbe/watermelondb/hooks";
import Terminal from "../data/model/Terminal";
import Location from "../data/model/Location";
import Layout from "../data/model/Layout";
import { useWithAppState } from "@towersystems/roam-common-native";
import { Q } from "@nozbe/watermelondb";
import React from "react";

export const useActiveTerminal = () => {
  const [loading, setLoading] = React.useState<boolean>(true);
  const [terminal, setTerminal] = React.useState<Terminal | null>(null);
  const database = useDatabase();

  const {
    updateAppState,
    appState: { terminalId },
  } = useWithAppState();

  React.useEffect(() => {
    if (terminalId) {
      reloadTerminal();
    } else {
      setLoading(false);
    }
  }, [terminalId]);

  const reloadTerminal = async () => {
    if (terminalId) {
      try {
        setLoading(true);
        const t = await database.get<Terminal>("terminals").find(terminalId);
        setTerminal(t);
      } catch (err) {
        // clear terminal if not found
        setTerminal(null);
        updateAppState({ terminalId: null });
        console.log(
          "Could not find location with ID. Clearing state.",
          terminalId
        );
      }
      setLoading(false);
    }
  };

  return {
    terminal,
    loading,
    reloadTerminal,
  };
};

export const useActiveLayout = () => {
  const [layout, setLayout] = React.useState<Layout | null>(null);
  const database = useDatabase();

  const {
    appState: { terminalId },
  } = useWithAppState();

  React.useEffect(() => {
    if (terminalId) {
      database
        .get<Layout>("layouts")
        .query(Q.where("terminal_id", Q.eq(terminalId)))
        .then((associatedLayout) => setLayout(associatedLayout[0]))
        .catch((err) => {
          console.log(err);
          setLayout(null);
        });
    }
  }, [terminalId]);

  return {
    layout,
  };
};

export const useActiveLocation = () => {
  const [location, setLocation] = React.useState<Location | null>(null);
  const database = useDatabase();

  const {
    updateAppState,
    appState: { locationId },
  } = useWithAppState();

  React.useEffect(() => {
    if (locationId) {
      database
        .get<Location>("locations")
        .find(locationId)
        .then((t) => setLocation(t))
        .catch((err) => {
          // clear terminal if not found
          updateAppState({ locationId: null });
          console.log(
            "Could not find locationId with ID. Clearing state.",
            locationId
          );
        });
    }
  }, [locationId]);

  return {
    location,
    locationId,
  };
};
